import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';
import { parseDuration, unParseDuration } from 'library/time';

class DurationPicker extends Component {
  constructor(props) {
    super(props);
    const { value } = props;
    this.state = {
      duration: parseDuration(value)
    };
    this.handleChange = this.handleChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const { value } = this.props;
    const { duration } = this.state;

    // Only update from props if the value actually changed from external source
    if (value !== nextProps.value) {
      const newDuration = parseDuration(nextProps.value);
      // Only update if it's different from our current normalized state
      if (unParseDuration(newDuration) !== unParseDuration(duration)) {
        this.setState({
          duration: newDuration
        });
      }
    }

    return true;
  }

  handleChange(newDuration) {
    const { onChange } = this.props;

    // Normalize the duration values
    let {
      days, hours, minutes, seconds
    } = newDuration;

    // Ensure all values are numbers
    days = days || 0;
    hours = hours || 0;
    minutes = minutes || 0;
    seconds = seconds || 0;

    if (seconds >= 60) {
      minutes += Math.floor(seconds / 60);
      seconds %= 60;
    }

    if (minutes >= 60) {
      hours += Math.floor(minutes / 60);
      minutes %= 60;
    }

    if (hours >= 24) {
      days += Math.floor(hours / 24);
      hours %= 24;
    }

    const normalizedDuration = {
      days, hours, minutes, seconds
    };

    this.setState({
      duration: normalizedDuration
    }, () => {
      onChange(unParseDuration(normalizedDuration));
    });
  }

  render() {
    const style = {
      display: 'inline-block',
      width: 'auto',
      marginRight: '5px'
    };

    const { duration } = this.state;
    const {
      showDays, showHours, showMinutes, disabled, minuteStep
    } = this.props;

    return (
      <div>
        {showDays && (
          <div className="ant-input-group-wrapper" style={style}>
            <span className="ant-input-wrapper ant-input-group">
              <InputNumber
                style={{ width: '60px' }}
                addonAfter="days"
                min={0}
                value={duration.days}
                defaultValue={0}
                onChange={(item) => {
                  this.handleChange({
                    ...duration,
                    days: item
                  });
                }}
                disabled={disabled}
              />
              <span className="ant-input-group-addon">days</span>
            </span>
          </div>
        )}
        {showHours
        && (
          <div className="ant-input-group-wrapper" style={style}>
            <span className="ant-input-wrapper ant-input-group">
              <InputNumber
                style={{ width: '60px' }}
                min={0}
                value={duration.hours}
                defaultValue={0}
                parser={(value) => {
                  const num = parseInt(value, 10) || 0;
                  if (num >= 24) {
                    setTimeout(() => {
                      let newHours = num;
                      let newDays = duration.days || 0;

                      if (newHours >= 24) {
                        newDays += Math.floor(newHours / 24);
                        newHours %= 24;
                      }

                      this.handleChange({
                        days: newDays,
                        hours: newHours,
                        minutes: duration.minutes || 0,
                        seconds: duration.seconds || 0
                      });
                    }, 0);
                    return num % 24;
                  }
                  return num;
                }}
                onChange={(item) => {
                  this.handleChange({
                    ...duration,
                    hours: item
                  });
                }}
                disabled={disabled}
              />
              <span className="ant-input-group-addon">hrs</span>
            </span>
          </div>
        )}
        {showMinutes
        && (
          <div className="ant-input-group-wrapper" style={style}>
            <span className="ant-input-wrapper ant-input-group">
              <InputNumber
                style={{ width: '60px' }}
                min={0}
                value={duration.minutes}
                defaultValue={0}
                parser={(value) => {
                  const num = parseInt(value, 10) || 0;
                  if (num >= 60) {
                    // Trigger normalization
                    setTimeout(() => {
                      let newMinutes = num;
                      let newHours = duration.hours || 0;
                      let newDays = duration.days || 0;

                      if (newMinutes >= 60) {
                        newHours += Math.floor(newMinutes / 60);
                        newMinutes %= 60;
                      }

                      if (newHours >= 24) {
                        newDays += Math.floor(newHours / 24);
                        newHours %= 24;
                      }

                      this.handleChange({
                        days: newDays,
                        hours: newHours,
                        minutes: newMinutes,
                        seconds: duration.seconds || 0
                      });
                    }, 0);
                    return num % 60;
                  }
                  return num;
                }}
                onChange={(item) => {
                  this.handleChange({
                    ...duration,
                    minutes: item
                  });
                }}
                disabled={disabled}
                step={minuteStep}
              />
              <span className="ant-input-group-addon">mins</span>
            </span>
          </div>
        )}
      </div>
    );
  }
}

DurationPicker.propTypes = {
  value: PropTypes.string, // eslint-disable-line react/require-default-props
  showDays: PropTypes.bool,
  showHours: PropTypes.bool,
  showMinutes: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  minuteStep: PropTypes.number
};

DurationPicker.defaultProps = {
  showDays: true,
  showHours: true,
  showMinutes: true,
  onChange() {
  },
  disabled: false,
  minuteStep: 1
};

export default DurationPicker;
